
import { Component, Prop, Vue } from "vue-facing-decorator";
import Arc1 from "@/components/prospect/brandPattern/arc1.vue";
import Arc2 from "@/components/prospect/brandPattern/arc2.vue";
import Arc3 from "@/components/prospect/brandPattern/arc3.vue";
import $ from "jquery";
@Component({
  components: {
    arc1: Arc1,
    arc2: Arc2,
    arc3: Arc3,
  },
}) class BrandPattern extends Vue {
  // Data with default values
  reload = true;
  animationSpeed = process.env.VUE_APP_BRANDPATTERN_SPEED
    ? parseInt(process.env.VUE_APP_BRANDPATTERN_SPEED)
    : 1500;
  arc1_color = "#387DFF";
  arc2_color = "#FFFFFF";
  arc3_color = "#FFFFFF";
  arc1_setter: Record<string, string> = { top: "-48px", right: "0px" };
  arc2_setter: Record<string, string> = { top: "163px", left: "-15px" };
  arc3_setter: Record<string, string> = { top: "220px", right: "30px" };
  circle_setter: Record<string, string> = {
    top: "430px",
    right: "0px",
    "animation-duration": `${this.animationSpeed}ms`,
  };

  // Props
  @Prop()
  public page!: string;
  public top;

  // Created method
  created() {
    this.setChanges();
  }

  // Computed values
  get arc1Setter() {
    return this.arc1_setter;
  }
  get arc2Setter() {
    return this.arc2_setter;
  }
  get arc3Setter() {
    return this.arc3_setter;
  }
  get circleSetter() {
    return this.circle_setter;
  }

  // Methods
  setChanges() {
    if (this.page == "VERIFY") {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#EEEFF0";
      this.arc3_color = "#EEEFF0";
      this.arc1_setter = { top: "-48px", right: "0px" };
      this.arc2_setter = { top: "163px", left: "-15px" };
      this.arc3_setter = { top: "220px", right: "30px" };
      this.circle_setter = {
        top: "430px",
        right: "0px",
        "animation-duration": `${this.animationSpeed}ms`,
      };
    } else if (this.page == "EMAILTHANKS") {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#FFFFFF";
      this.arc3_color = "#FFFFFF";
      this.arc1_setter = { top: "-48px", right: "10px" };
      this.arc2_setter = { top: "115px", left: "0px" };
      this.arc3_setter = { bottom: "0px", right: "30px" };
      this.circle_setter = {
        top: "400px",
        right: "0px",
        "animation-duration": `${this.animationSpeed}ms`,
      };
    }
  }

  reloadToggle() {
    this.reload = !this.reload;
    $(this.$refs.circlediv as any).removeClass("top-layer");
    setTimeout(() => {
      $(this.$refs.circlediv as any).addClass("top-layer");
    }, 0);
  }
}

const __default__ = BrandPattern
import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "8b992378": (_ctx.top)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__